import * as React from 'react';
import { useSelector } from 'react-redux';

import { getBusinessLoungeByTypes } from '../../../store/order/selectors';
import Business from '../../../../CheckoutAdditionalService/components/Business/Business';

const OrderMultipleBusinessBlockSlot: React.FC = () => {
	const businessLoungeByTypes = useSelector(getBusinessLoungeByTypes);

	return (
		<>
			{businessLoungeByTypes.map((services, index) => (
				<Business key={index} services={services} />
			))}
		</>
	);
};

export default OrderMultipleBusinessBlockSlot;
